import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'

import MainLayout from './main-layout'

const MainLayoutRoute = ({ component, ...rest }) => (
  <Route
    {...rest}
    render={() => (
      <MainLayout>
        {component}
      </MainLayout>
    )}
  />
)

MainLayoutRoute.propTypes = {
  component: PropTypes.element
}

MainLayoutRoute.defaultProps = {
  component: null
}

export default MainLayoutRoute
